import React from 'react';
import { StyledBackground } from './AdUnitPlaceholder.styles.mjs';
export { adUnitPlaceholderType } from './AdUnitPlaceholder.styles.mjs';

const AdUnitPlaceholder = ({ children, template, sizes }) => {
    return (React.createElement(StyledBackground, { template: template, sizes: sizes }, children));
};

export { AdUnitPlaceholder as default };
//# sourceMappingURL=AdUnitPlaceholder.mjs.map
